import { useScreen } from '../../screens/useScreen';
import { WizardNavigationFooterProps } from './wizard-navigation-footer.component';

interface ViewProps {
    finalStep: boolean;
    onBack?: (e: any) => void;
}

const useWizardNavigationFooter = (props: WizardNavigationFooterProps): ViewProps => {
    const { onBack, backEnabled, finalStep } = useScreen();

    return {
        finalStep,
        onBack: props.onBack ? props.onBack : backEnabled ? onBack : undefined
    };
};

export default useWizardNavigationFooter;
